export interface IEditPublisherViewModel {
    id: number;
    name: string;
    countryCodes: Array<string>;
    secretKey: string;
    callbackUrl: string;
    providers?: Array<string>;
}

export class IPublisherInfoModel {
    name: string;
    groupId: number;
    requiresSignature: boolean;
    signature: string;
    showRatings: boolean;
    color: string;
}

export class IPublisherSettingsModel {
    deviceType: number;
    url: string;
    version: string;
    bundleId: string;
    showCreditNotification: boolean;
    isRefundingCredit: boolean;
}

export class IPublisherMappingsModel {
    countryId: number;
    providerIdsOrdered: Array<ProviderOrder>;
}

export class ProviderOrder {
    providerId: number;
    order: number;
}

export class CreatePublisherViewModel {
    name: string;
    groupId: number;
    requiresSignature: boolean;
    signature: string;
    showRatings: boolean;
    color: string;
    publisherSettings: IPublisherSettingsModel[];
    publisherMappings: IPublisherMappingsModel[];
}


// WEBPACK FOOTER //
// ./src/app/publishers/publisher.model.ts